import React, {useEffect, useState} from 'react'
import {Button, Checkbox, Col, Row, Table, Tag} from "antd";
import OfferDetailActions from "./OfferDetailActions";
import OfferDetailShippingModal from "./OfferDetailShippingModal";

const OfferDetailTable = ({offer}) => {

    const [sortedList, setSortedList] = useState([])
    const [disableModalButton, setDisableModalButton] = useState(true)
    const [modal, setModal] = useState(false)

    useEffect(() => {
        let sorted = offer.bid.contentOfBidList.map((item) => {
            return {
                key: item.id,
                offerStock: `${item?.stock?.code || ''} - ${item?.stock?.name || ''}`,
                offerStockId: item?.stock?.id || '',
                offerQuantity: item.amount,
                offerGift: item.gift || false,
                offerDiscount: item.discount ? item.discount : '-',
                offerSecondDiscount: item.discount2 ? item.discount2 : '-',
                offerUnit: item?.stock?.unit || '',
                offerPrice: item.hasOwnProperty('linePrice') ? item.linePrice : item.stock.price,
                offerCurrency: item.selectedCurrency,
                offerLineTotal: item.lineTotal,
                offerDeadline: item.deadline,
                stockQuantity: item?.stock?.quantity || '',
                bidRowStatus: item.bidStatus
            }
        })
        setDisableModalButton(!(offer.bid.bidStatus === 'POSITIVE' && !offer.shippingOrders.length));
        setSortedList(sorted);
    }, [offer])

    const columns = [
        {
            title: 'Stok Adı',
            dataIndex: 'offerStock',
        },
        {
            title: 'Miktar',
            dataIndex: 'offerQuantity',

        },
        {
            title: 'Birimi',
            dataIndex: 'offerUnit',

        },
        {
            title: 'Birim Fiyatı',
            dataIndex: 'offerPrice',
            render: (t) => new Intl.NumberFormat().format(t)
        },
        {
            title: 'Para Birimi',
            dataIndex: 'offerCurrency',

        },
        {
            title: 'İskonto %',
            dataIndex: 'offerDiscount'
        },
        {
            title: 'İskonto 2',
            dataIndex: 'offerSecondDiscount'
        },
        {
            title: 'Hediye',
            dataIndex: 'offerGift',
            render: (t, r) => <Checkbox checked={r.offerGift} disabled={true} />
        },
        {
            title: 'Toplam',
            dataIndex: 'offerLineTotal',
            render: (t) => new Intl.NumberFormat().format(t)

        },
        {
            title: 'Termin Tarihi',
            dataIndex: 'offerDeadline',

        },
        {
            title: 'İşlemler',
            dataIndex: 'offerActions',
            render: (text, record) => record.bidRowStatus === 'POSITIVE' ?
                <OfferDetailActions record={record} offer={offer}/> :
                record.bidRowStatus === 'WAITING' ? <Tag color={'orange'}>Onay Bekliyor</Tag> :
                <Tag color={'red'}>Olumsuz</Tag>
        }
    ]

    const changeModalStatus = () => {
        setModal(!modal)
    }

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <h3>Teklif İçeriği</h3>
                </Col>
                <Col span={3}>
                    <Button
                        style={{paddingBottom: 0}}
                        type={"link"}
                        onClick={changeModalStatus}
                        disabled={disableModalButton}
                    >
                        Sevk İrsaliyesi Oluştur
                    </Button>
                </Col>
            </Row>
            <Table scroll={{x: 'max-content'}} columns={columns} dataSource={sortedList} pagination={false}/>
            {
                modal ? <OfferDetailShippingModal offer={offer} modalCloser={changeModalStatus} modal={modal} /> : null
            }
        </React.Fragment>
    )
}
export default OfferDetailTable